/* Warenkorb: Rabattcode-Feld einklappbar - 7 O'CLOCK
   Angelegt: 2026-09-22

   Baut das Rabattcode-Feld im Mini-Warenkorb zu einem Accordion um:
   Zeile "Ich habe einen Rabattcode" bleibt sichtbar, Eingabefeld + Button
   liegen darunter und sind standardmaessig zugeklappt.

   Bewusst als Laufzeit-Enhancement, damit das von Liquify generierte
   snippets/mini_cart.liquid unveraendert bleibt.
   Styles: assets/custom-typography.css
   Eingebunden ueber snippets/gtm-head.liquid.

   Hinweis: der sichtbare Zustand haengt an der Klasse .is-open am Wrapper,
   nicht an aria-expanded - das Finsweet-a11y-Script im Theme schreibt
   aria-expanded selbst nach. */
(function () {
  'use strict';

  var WRAPPER = '.mini-cart_discount-wrapper';
  var PANEL_ID = 'mini-cart-discount-panel';
  var CHEVRON =
    '<svg class="mini-cart_discount-chevron" width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">' +
    '<path d="M6 9l6 6 6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function enhance(wrapper) {
    if (!wrapper || wrapper.dataset.discountCollapsible === '1') return;

    var label = wrapper.querySelector('.text-weight-bold');
    var content = wrapper.querySelector('.mini-cart_input-wrapper');
    if (!label || !content) return;

    wrapper.dataset.discountCollapsible = '1';
    // Schaltet das Accordion-CSS scharf (Wrapper ist im Theme eine Flex-Zeile)
    wrapper.classList.add('is-collapsible');

    // Label in einen Button verschieben
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'mini-cart_discount-toggle';
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-controls', PANEL_ID);
    label.parentNode.insertBefore(toggle, label);
    toggle.appendChild(label);
    toggle.insertAdjacentHTML('beforeend', CHEVRON);

    // Eingabefeld in ein aufklappbares Panel verschieben.
    // Zusaetzlicher Inner-Wrapper, weil das Eingabefeld Padding + Border hat.
    var panel = document.createElement('div');
    panel.className = 'mini-cart_discount-panel';
    panel.id = PANEL_ID;
    var inner = document.createElement('div');
    inner.className = 'mini-cart_discount-panel-inner';
    content.parentNode.insertBefore(panel, content);
    panel.appendChild(inner);
    inner.appendChild(content);

    var input = panel.querySelector('#mini-cart-discount');

    function setOpen(open, focusInput) {
      wrapper.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open && focusInput && input) input.focus();
    }

    toggle.addEventListener('click', function () {
      setOpen(!wrapper.classList.contains('is-open'), true);
    });

    // Bereits eingegebener oder gespeicherter Code: direkt offen zeigen
    if (input && input.value && input.value.trim() !== '') setOpen(true, false);
  }

  function run() {
    var nodes = document.querySelectorAll(WRAPPER);
    for (var i = 0; i < nodes.length; i++) enhance(nodes[i]);
    return nodes.length > 0;
  }

  function init() {
    if (run()) return;
    // Mini-Warenkorb wird teils erst spaeter in den DOM gehaengt
    var observer = new MutationObserver(function () {
      if (run()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
